var parent = require('../../es/instance/sort');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/instance/sort.js
// module id = 6488
// module chunks = 25